<template>
<div class="main featured-collections">

	<div class="list-view">

		<div class="sub-header">
			<div class="input-with-control">
				<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="setFilter()" v-focus>
				<div class="button action input-go" @click="setFilter()"><i class="fas fa-search"></i></div>
			</div>
			<div class="controls">
				<pagination :paging="paging" @updatePage="goToPage"></pagination>
			</div>
		</div>

		<div v-if="showFilters" class="left-sidebar filters">

			<div class="title">Filter the list of featured collections based on their published status...</div>

			<ul v-if="isAdmin" class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
					<label>Inactive</label>
				</li>
			</ul>
			<ul v-else class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.published ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('published')"></span>
					<label>Published</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.unpublished ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('unpublished')"></span>
					<label>Unpublished</label>
				</li>
			</ul>

			<div :class="['button', hasFilters ? 'neutral' : 'disabled' ]" @click="clearFilters(true)">Clear Filters</div>
			<div v-if="isAdmin" class="button primary action" @click="newItem()">Add New</div>

			<div class="divider"></div>
			<div v-if="!autoPilotEnabled && !isAdmin" class="label">Published means you have selected a featured collection for display on your website's landing page.</div>
			<div v-if="autoPilotEnabled" class="label">
				<p>These featured collections are part Auto Pilot and cannot be changed.</p>
				<router-link to="/website/auto-pilot">Manage Auto Pilot...</router-link>
			</div>

		</div>

		<div class="main-content detail" v-if="!loading">
			<h2>Featured Collections</h2>

			<div v-if="featuredCollections.length > 0" class="list-grid">
				<div v-for="(featuredCollection, index) in featuredCollections" class="cell" @click="editItem(featuredCollection)">
					<div style="text-align: center;">
						<img :src="featuredCollection.image_src">
					</div>
					<button v-if="!autoPilotEnabled && (!isAdmin || forAutoPilot) && !featuredCollection.featured_collection_page_id" class="primary" style="float: right;" @click="saveFeaturedCollection(index)">Publish</button>
					<button v-else-if="!autoPilotEnabled && (!isAdmin || forAutoPilot)" class="delete" style="float: right;" @click="saveFeaturedCollection(index)">Unpublish</button>
					<div class="title">{{ featuredCollection.description }}</div>
				</div>
			</div>
			<div v-else class="empty-list">
				This list is empty
			</div>

		</div>

        <loading v-else></loading>
	</div>

	<div class="modal" v-if="showEditModal">
		<div class="inner">
			<h2>{{ detail.featured_collection_id ? 'Update' : 'Add' }} Featured Collection</h2>
			<div class="content">
				<div class="two-one-columns">
					<div class="image-preview">
						<img v-if="detail.image_src" :src="detail.image_src">
					</div>
					<div>
						<vue-dropzone @vdropzone-success="uploadSuccess" ref="imageDropzone" id="image_dropzone" :options="dropzoneOptions"></vue-dropzone>
					</div>
				</div>
				<label>Description</label>
				<input type="text" v-model="detail.description" />
				<label>Links To</label>
				<input type="text" v-model="detail.link_url" />
				<div v-if="detail.featured_collection_id">
					<input type="checkbox" v-model="detail.inactive" /> <label>Inactive</label>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showEditModal = false">Cancel</div>
				<div class="button action spaced" @click="saveItem()">Save</div>
			</div>
		</div>
	</div>

	<help-popup :helpLink="{87:'Featured Collections', 106:'Website Template: Featured Collections'}" :tours="false"></help-popup>

</div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'menus',
	components: {
        'vue-dropzone': vue2Dropzone,
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			showFilters: true,
			filters: {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			},
			paging: {},
			message: '',
			clientId: '',
			featuredCollections: [],
			showEditModal: false,
			detail: {},
			forAutoPilot: false,
			autoPilotEnabled: false
		}
	},
	created() {
		this.forAutoPilot = this.$route.query.for_auto_pilot
		if (!this.getAdministratorFlag) {
			this.getAutoPilotEnabled()
		}
		this.getList()
	},
	computed: {
		hasFilters() {
			let filterIsSet = false
			for (var property in this.filters) {
				switch (property) {
					case 'hostname':
					case 'page':
					case 'source':
					case 'shopping_cart_id':
						break
					default:
						filterIsSet = this.filters[property] && this.filters[property] != ''
						break
				}
				if (filterIsSet) {
					return true
				}
			}
			return false
		},
		isAdmin() {
			return this.getUser.user_type_code.indexOf('ADMIN') > -1
		},
		dropzoneOptions() {
			return {
				url: this.getApiEndpoint + '?action=upload_featured_collection_image',
				withCredentials: true,
				uploadMultiple: false,
				paramName: 'upload_file',
				maxFilesize: 2.0,
				addRemoveLinks: true,
				thumbnailMethod: 'contain',
				dictDefaultMessage: 'Drop an image file here, or click to find an image...',
				params: {
					fd_token: this.$getCookie('dashboard_token'),
					source: 'WEBSITE',
					featured_collection_id: this.detail.featured_collection_id,
					image_id: this.detail.image_id || ''
				}
			}
		},
	},
	methods: {
		getAutoPilotEnabled() {
			this.apiCall({ destination: 'get_item_preference', data: { preference_code: 'ENABLE_AUTO_PILOT' } }).then(obj => {
				this.autoPilotEnabled = obj.ENABLE_AUTO_PILOT != ''
			}).catch(err => {
				console.log(err)
			})
		},
		getList() {
			this.loading = true
			this.apiCall({ destination: 'get_list_featured_collections', data: this.filters } ).then(obj => {
				this.loading = false
				this.featuredCollections = obj.featured_collections
			}).catch(err => {
				console.log(err)
			})
		},
		saveFeaturedCollection(index) {
			this.apiCall({ destination: 'save_item_featured_collection', data: { featured_collection_page_id: this.featuredCollections[index].featured_collection_page_id, featured_collection_id: this.featuredCollections[index].featured_collection_id, link_url: this.featuredCollections[index].link_url } } ).then(obj => {
				if (obj.status == 'success') {
					this.getList()
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		},
		setFilter() {
			this.filters.page = 1
			this.getList()
		},
		toggleFilter(which) {
			let currentValue = this.filters[which]
			this.filters.published = ''
			this.filters.unpublished = ''
			this.filters[which] = !currentValue
			this.filters.page = 1
			this.getList()
		},
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				published: false,
				unpublished: false
			}
			if (getList) {
				this.getList()
			}
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		editItem(item) {
			if (!this.isAdmin || this.forAutoPilot) { return }
			this.detail = item
			this.showEditModal = true
		},
		newItem() {
			if (!this.isAdmin) { return }
			this.detail = {}
			this.showEditModal = true
		},
		uploadSuccess(file, response) {
			var response = JSON.parse(response)
			if (response.image) {
				this.detail.image_src = response.image.image_src
				this.detail.image_id = response.image.image_id
			}
			this.$refs['imageDropzone'].removeAllFiles()
		},
		theUploadAdapterPlugin(editor) {
			editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
				return new CDSUploadAdapter(loader);
			}
		},
		saveItem() {
			if (!this.isAdmin) { return }
			this.apiCall({ destination: 'save_item_featured_collection_admin', data: this.detail } ).then(obj => {
				if (obj.status == 'success') {
					this.showEditModal = false
					this.getList()
				} else {
					console.log(obj)
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
